/**
 * @license
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import * as Blockly from 'blockly/core';

Blockly.Toolbox.prototype.onKeyDown_ = function () {
  // Do nothing since keyboard functionality should be entirely handled by the
  // keyboard navigation plugin.
};
